<template>
    <modal name="my-gifts" @before-open="beforeOpen" @before-close="beforeClose" :classes="['v--modal', 'my-gifts']"
        :width="730" :height="'auto'" :scrollable="true" :adaptive="true">
        <div class="modal-title">{{ title }}</div>
        <div @click="close" ref="close" class="modal-close"></div>
        <div class="modal-body">
            <div v-if="loader"><button class="button button-loader"></button></div>
            <div v-else-if="giftsIsEmpty('userGifts')">
                {{ $t("sendGift.giftListEmpty") }}
            </div>
            <div v-else class="my-gifts-list">
                <GiftItem v-if="giftObj.id" :id="id" :gift="giftObj" :event="eventId"></GiftItem>
                <div v-else v-for="(gift, index) in userGifts" :ref="'element' + index" :key="index"
                    class="my-gifts-item-wrapper">
                    <GiftItem :id="id" :gift="gift"></GiftItem>
                </div>
                <div v-if="moreLoader" class="button-loader"></div>
            </div>
            <div v-else>
                {{ $t("sendGift.giftListEmpty") }}
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import GiftItem from "@/components/Blocks/GiftItem";
import { observeListEnd } from "@/mixins/observeListEnd";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "MyGifts",
    props: {
        i18n: Object,
    },
    mixins: [observeListEnd, checkScroll],
    components: {
        GiftItem,
    },
    data() {
        return {
            id: "",
            giftObj: {},
            title: "",
            loader: true,
            buttonLoader: false,
            // closeFixed: false,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
            eventId: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            userGifts: "gifts/fetchUserGifts",
            userGiftsNext: "gifts/fetchUserGiftsNext",
            giftsCount: "gifts/fetchGiftsCount",
            giftsIsEmpty: "gifts/isEmpty",
        }),
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
            this.loader = true;
            this.id = event.params.id;
            this.giftObj = event.params.gift || {};
            if (event.params.gift) {
                this.title = this.giftObj.from_user
                    ? this.$t("sendGift.giftFromUser") + this.giftObj.from_user.name
                    : this.$t("sendGift.giftAnonymousUser");
            } else {
                this.title =
                    this.id == this.user.id
                        ? this.$t("sendGift.myGifts")
                        : this.$t("sendGift.giftsUser") + event.params.name;
            }
            this.observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting === true) {
                        this.showMore();
                    }
                },
                { threshold: [0] }
            );
            if (event.params.eventId) {
                this.getGifts();
                this.eventId = event.params.eventId;
            } else {
                this.loader = false;
                this.updateMoreIndex();
                this.observeListEnd("element");
            }
            //console.log(this.giftObj);
            //console.log(this.gift);
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        getGifts() {
            this.$store
                .dispatch("gifts/getMyGifts", this.user.id)
                .then(() => {
                    this.loader = false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                })
                .catch(() => {
                    this.loader = false;
                });
        },
        updateMoreIndex() {
            this.moreIndex = this.userGifts.length - 2;
        },
        showMore() {
            if (this.userGiftsNext) {
                this.moreLoader = true;
                this.$store
                    .dispatch("gifts/getUserNext")
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        close() {
            this.$modal.hide("my-gifts");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_user-item";
</style>

<style lang="scss">
@import "~@/assets/styles/layout/_my-gifts";
</style>
